import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { RogueAccessPointsComponent } from '@app/features/mists/modules/rogue-ap-audit/rogue-ap-audit.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        RogueAccessPointsComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class RogueAccessPointsModule {}